// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9z-3";
export var contentContainer = "_9z-0";
export var editorContainer = "_9z-1";
export var quillInputForm = "_9z-2";
export var zoneDivider = "_9z-4";